import { Box, Typography, Link } from '@mui/material';

/** ICP备案号（工信部要求：备案号需链接至工信部备案系统官网） */
export const ICP_NUMBER = '琼ICP备2026012182号';
const ICP_URL = 'https://beian.miit.gov.cn/';

/**
 * ICP备案页脚
 * 全站统一引用（管理端布局 / 代理端布局 / 登录页）
 */
export function IcpFooter() {
  return (
    <Box
      component="footer"
      sx={{
        textAlign: 'center',
        py: 2,
        mt: 'auto',
      }}
    >
      <Typography variant="caption" color="textSecondary">
        <Link
          href={ICP_URL}
          target="_blank"
          rel="noopener noreferrer"
          color="inherit"
          underline="hover"
        >
          {ICP_NUMBER}
        </Link>
      </Typography>
    </Box>
  );
}
